<script setup
        lang="ts">
import { useGdprStore } from '@reshepe/stores';
import ButtonAction     from '../button/action/button-action.vue';
import LinkInternal     from '../link/internal/link-internal.vue';
import LinkExternal     from '../link/external/link-external.vue';

withDefaults(defineProps<{
    astro?: boolean;
}>(), {
    astro: false,
});

const gdprStore = useGdprStore();

let policy_url   = '/cookies/policy';
let settings_url = '/cookies/settings';

const is_not_landing = !!import.meta.env.VITE_LANDING_URL;

if (is_not_landing) {
    policy_url   = import.meta.env.VITE_LANDING_URL + policy_url;
    settings_url = import.meta.env.VITE_LANDING_URL + settings_url;
}
</script>

<template>
    <div v-if="!gdprStore.closed"
         :class="[
             'fixed',
             'bottom-0 left-0',
             'z-max',
             'inline-flex flex-col tablet:flex-row items-center justify-between',
             'w-full',
             'p-6',
             'bg-secondary-700',
             'shadow-rise',
             'text-base text-left',
         ]">
        <p :class="[
            'text-white-600',
        ]">
            we use cookies to improve your experience and for analytics. Learn more in our
            <LinkExternal v-if="is_not_landing"
                          text="cookies policy"
                          contrast
                          :url="policy_url" />
            <LinkInternal v-else
                          text="cookies policy"
                          :url="policy_url"
                          contrast
                          :astro="astro" />
        </p>
        <div :class="[
            'flex items-center',
            'mt-8 tablet:mt-0',
        ]">
            <ButtonAction text="reject"
                          icon="i-clarity:times-line"
                          :shrink="false"
                          @click="gdprStore.reject()" />
            <ButtonAction text="accept"
                          icon="i-ic:round-check"
                          highlight
                          :shrink="false"
                          @click="gdprStore.accept()" />
        </div>
    </div>
</template>
